if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        this.ignoreSlideChanged = false;
        this.ignoreTimeout = null;
        this.thumbnailSyncFrame = null;

        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', (event) => {
          if (this.ignoreSlideChanged) return;
          this.onSlideChanged(event);
        });

        // GEWOLLT: Beim Wischen durch die Bilder (mobil) laufen die Vorschaubilder mit.
        const viewerSlider =
          this.elements.viewer.slider || this.elements.viewer.querySelector('[id^="Slider-"]');
        viewerSlider?.addEventListener('scroll', () => this.scheduleThumbnailSync(), { passive: true });

        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch.querySelector('button')?.addEventListener('click', () => {
            this.setActiveMedia(mediaToSwitch.dataset.target, false);
          });
        });

        if (this.dataset.desktopLayout?.includes('thumbnail') && this.mql.matches) {
          this.removeListSemantic();
        }
      }

      scheduleThumbnailSync() {
        if (this.thumbnailSyncFrame) cancelAnimationFrame(this.thumbnailSyncFrame);
        this.thumbnailSyncFrame = requestAnimationFrame(() => {
          this.thumbnailSyncFrame = null;
          this.syncThumbnailFromViewer();
        });
      }

      syncThumbnailFromViewer() {
        const slider = this.elements.viewer.slider || this.elements.viewer.querySelector('[id^="Slider-"]');
        if (!slider || !this.elements.thumbnails) return;

        const visibleMedia = Array.from(this.elements.viewer.querySelectorAll('[data-media-id]')).filter(
          (media) => media.offsetWidth > 0
        );
        if (!visibleMedia.length) return;

        const viewportCenter = slider.scrollLeft + slider.clientWidth / 2;
        const activeMedia = visibleMedia.reduce((closest, media) => {
          const mediaCenter = media.offsetLeft + media.offsetWidth / 2;
          const closestCenter = closest.offsetLeft + closest.offsetWidth / 2;
          return Math.abs(mediaCenter - viewportCenter) < Math.abs(closestCenter - viewportCenter) ? media : closest;
        });

        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((media) => {
          media.classList.toggle('is-active', media === activeMedia);
        });

        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${activeMedia.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) return;

        // slideChanged kurzzeitig ignorieren, damit die Auswahl nicht ueberschrieben wird.
        this.ignoreSlideChanged = true;
        if (this.ignoreTimeout) clearTimeout(this.ignoreTimeout);
        this.ignoreTimeout = setTimeout(
          () => {
            this.ignoreSlideChanged = false;
          },
          this.mql.matches ? 600 : 1500
        );

        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia.classList.add('is-active');

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({
              left: activeMedia.offsetLeft,
              behavior: 'smooth',
            });
          }

          // Waehrend des gewollten Scrolls nach oben (Kaching-Swatch-Klick) darf Dawn
          // NICHT gegenscrollen. Der Scroll selbst liegt in tanera-kaching-swatch-scroll.js.
          // if (window.__taneraKachingSwatchSelection) return;

          // const activeMediaRect = activeMedia.getBoundingClientRect();
          // if (activeMediaRect.top > -0.5) return;
          // window.scrollTo({ top: activeMediaRect.top + window.scrollY, behavior: 'smooth' });
        });

        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;

        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        if (!activeThumbnail) return;

        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button')?.setAttribute('aria-current', true);

        if (typeof this.elements.thumbnails.isSlideVisible !== 'function') return;
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider?.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        if (!this.elements.liveRegion) return;
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
